import { render } from "./klaviyo-bis-form.vue?vue&type=template&id=4be6547b"
import script from "./klaviyo-bis-form.vue?vue&type=script&lang=js"
export * from "./klaviyo-bis-form.vue?vue&type=script&lang=js"

import "./klaviyo-bis-form.vue?vue&type=style&index=0&id=4be6547b&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__